module.exports = "https://coursera_assets.s3.amazonaws.com/images/7dfbc062966adf6a1bf4d6cae559e844.png";